const SCRIPT_SRC = "/charting_library/charting_library.js";

let loadPromise: Promise<void> | null = null;

/**
 * Lazily injects the TradingView charting_library script on first call.
 * Subsequent calls return the cached promise so the script is only
 * fetched and evaluated once. Keeps the ~2.5MB library out of the
 * landing bundle entirely — it only loads on chart-bearing routes.
 */
export function loadTradingViewLibrary(): Promise<void> {
	if (typeof window === "undefined") {
		return Promise.reject(new Error("TradingView requires a browser"));
	}

	if (window.TradingView) {
		return Promise.resolve();
	}

	if (loadPromise) {
		return loadPromise;
	}

	loadPromise = new Promise<void>((resolve, reject) => {
		const existing = document.querySelector<HTMLScriptElement>(
			`script[src="${SCRIPT_SRC}"]`,
		);
		if (existing) {
			existing.addEventListener("load", () => resolve(), { once: true });
			existing.addEventListener(
				"error",
				() => {
					loadPromise = null;
					reject(new Error("TradingView script failed to load"));
				},
				{ once: true },
			);
			return;
		}

		const script = document.createElement("script");
		script.src = SCRIPT_SRC;
		script.async = true;
		script.addEventListener("load", () => resolve(), { once: true });
		script.addEventListener(
			"error",
			() => {
				loadPromise = null;
				reject(new Error("TradingView script failed to load"));
			},
			{ once: true },
		);
		document.head.appendChild(script);
	});

	return loadPromise;
}
